import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import classNames from 'classnames'

const Button = ({
  type,
  text,
  loading,
  classes,
  onClick,
  loadingText = "Loading...",
}) => {
  const btnClasses = classNames(classes, {
    "myBtn group relative flex justify-center py-2 px-3 sm:px-8 sm:py-3 text-xs sm:text-sm font-medium rounded text-white bg-blue-100 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition duration-100 ease-in-out shadow-lg" : true 
  })

  //console.log(classes)
return (
  <button
    type={type}
    onClick={onClick}
    className={btnClasses}
  >
    {loading ? (
      <span className="flex items-center">
        <FontAwesomeIcon icon={faCircleNotch} spin />
        <span className="ml-0 sm:ml-2">{loadingText}</span>
      </span>
    ) : (
      <span>{text}</span>
    )}
  </button>
)};

export default Button;
